import React from 'react';
import { Container, Thumbnail } from './styles';
import DefaultAvatar from '../../assets/icons/User.png';

import { InfoContainer, TextContainer, TitleContainer, PersonalInfoWrapper, NameWrapper, LinearWrapper } from './styles';

const InfoWrapper = ({ title, text }: { title: string; text: string }) => {
  return (
    <InfoContainer>
      <TitleContainer>{title}</TitleContainer>
      <TextContainer>{text}</TextContainer>
    </InfoContainer>
  );
};

const getSeason = (text: string) => {
  const keywords = ["Pre-season", "In-season", "Off-season"];
  let season: string = '';
  keywords.forEach(item => {
    let word = text.toUpperCase().includes(item.toUpperCase());
    if (word) season = item;
  })
  return season;
}

export default ({ selectedPlayer }: { selectedPlayer: any }) => {
  return (
    <Container>
      <Thumbnail src={selectedPlayer.picture || DefaultAvatar} />
      <PersonalInfoWrapper>
        <NameWrapper>{selectedPlayer.name}</NameWrapper>
        <LinearWrapper>
          <TitleContainer>Age</TitleContainer>
          <TextContainer>{selectedPlayer.age || '-'}</TextContainer>
          <TitleContainer>Gender</TitleContainer>
          <TextContainer>{selectedPlayer.gender || '-'}</TextContainer>
        </LinearWrapper>
      </PersonalInfoWrapper>
      <InfoWrapper 
        title="Season" 
        text={selectedPlayer.season ? getSeason(selectedPlayer.season) : '-'} 
      />
      <InfoWrapper title="Primary Position" text={selectedPlayer.primaryPosition || '-'} />
      <InfoWrapper title="Secondary Position" text={selectedPlayer.secondaryPosition || '-'} />
      <InfoWrapper title="Bat" text={selectedPlayer.bat || '-'} />
      <InfoWrapper title="Throw" text={selectedPlayer.throw || '-'} />
      <InfoWrapper title="Playing Level" text={selectedPlayer.playingLevel || '-'} />
      <InfoWrapper title="Height" text={selectedPlayer.height || '-'} />
      <InfoWrapper title="Weight" text={selectedPlayer.weight || '-'} />
      <InfoWrapper title="Middle Finger" text={selectedPlayer.middleFinger || '-'} />
      <InfoWrapper title="Upper Arm" text={selectedPlayer.upperArm || '-'} />
      <InfoWrapper title="Forearm" text={selectedPlayer.foreArm || '-'} />
    </Container>
  );
};
